import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {Header} from '../../../../components/primitives/header';
import {DisplaySmall} from '../../../../components/primitives/display';
import messages from './messages';
import PasswordForm from 'containers/PasswordForm';
import GraphQLError from 'components/GraphQLError';
import {WithSetNewPassword} from '../../../../api/users/WithSetNewPassword';


export class SetNewPassword extends React.Component {
    static propTypes = {
        onNewPasswordSet: PropTypes.func
    };

    static defaultProps = {
        onNewPasswordSet: () => undefined
    };

    savePassword = (setPassword, password) => {
        setPassword(password).then(() => {
            this.props.onNewPasswordSet();
        });
    };

    render() {
        return (
            <Wrapper>
                <Header>
                    <DisplaySmall>
                        <FormattedMessage {...messages.setupPasswordTitle}/>
                    </DisplaySmall>
                </Header>
                <WithSetNewPassword>
                    {({setNewPassword, loading, error}) => (
                        error ? <GraphQLError error={error}/>
                            : <PasswordForm
                                save={this.savePassword.bind(null, setNewPassword)}
                                loading={loading}/>
                    )}
                </WithSetNewPassword>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`

`;


export default SetNewPassword;
